<template>
  <div class="ac-card-content">
    <div class="ac-header-container flex-column">
      <div class="flex-row just-between" style="width: 100%;">
        <div class="ac-header">
          {{ address.id ? 'Edit' : 'Add' }} Address
        </div>
        <button class="ac-close-button" @click="toggle(false)">
          <img src="@shared/assets/img/general/x-black.png" alt="x" class="ac-close">
        </button>
      </div>
      <div class="sac__font-16 n40">
        Addresses cannot be removed after association with an order or agreement
      </div>
    </div>
    <div class="ac-body-container">
      <div class="flex-row">
        <div v-if="type !== 'BUSINESS'" class="ac-input-container">
          <div class="ac-input-header">
            First Name
          </div>
          <SACInput
            field="firstName"
            placeholder="Enter First Name"
            :value="firstName"
            :error="errorObj.firstNameErr"
            :change="onChange"
          />
        </div>
        <div v-if="type !== 'BUSINESS'" class="ac-input-container ml-4">
          <div class="ac-input-header">
            Last Name
          </div>
          <SACInput
            field="lastName"
            placeholder="Enter Last Name"
            :value="lastName"
            :error="errorObj.lastNameErr"
            :change="onChange"
          />
        </div>
      </div>
      <div class="ac-input-container">
        <div class="ac-input-header">
          Street Address
        </div>
        <SACInput
          field="address1"
          placeholder="Enter Street Address"
          :value="address1"
          :error="errorObj.address1Err"
          :change="onChange"
        />
      </div>
      <div class="ac-input-container">
        <div class="ac-input-header">
          Street Address Line 2 (optional)
        </div>
        <SACInput field="address2" placeholder="Enter Suite #, Bldg #, Etc" :value="address2" :change="onChange" />
      </div>
      <div class="flex-row">
        <div class="ac-input-container">
          <div class="ac-input-header">
            City
          </div>
          <SACInput field="city" placeholder="Enter City" :value="city" :error="errorObj.cityErr" :change="onChange" />
        </div>
        <div class="ac-input-container ml-4">
          <div class="ac-input-header">
            State
          </div>
          <SACDropdown
            :options="states"
            :value="state"
            optionLabel="state"
            optionValue="abbreviation"
            placeholder="Select State"
            field="state"
            :error="errorObj.stateErr"
            :change="onChange"
          />
        </div>

        <div class="ac-input-container ml-4">
          <div class="ac-input-header">
            Zip
          </div>
          <SACInput field="zip" placeholder="Enter Zip" :value="zip" :error="errorObj.zipErr" :change="onChange" />
        </div>
      </div>
      <div class="ac-input-container">
        <div class="ac-input-header">
          Country
        </div>
        <SACDropdown
          :options="countries"
          :value="country"
          optionLabel="country"
          optionValue="code"
          placeholder="Select Country"
          field="country"
          :error="errorObj.countryErr"
          :change="onChange"
        />
      </div>
    </div>
    <div class="ac-footer-container just-between">
      <button
        v-if="address.id && type !== 'BUSSINESS'"
        class="address-del-btn"
        @click="toggle(true, 'delete-address', address)"
      >
        Delete
      </button>
      <div v-else />
      <div>
        <button class="address-icn-btn" @click="toggle(false)">
          Cancel
        </button>
        <button class="address-fill-btn" @click="updatePartnerConfig">
          Save
        </button>
      </div>
    </div>
    <ProcessOverlay :show="updating" text="Saving" />
  </div>
</template>

<script>
import SACInput from '@shared/components/sac/SACInput.vue';
import SACDropdown from '@shared/components/sac/SACDropdown.vue';
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';

export default {
  name: 'EditAddressPopup',
  components: {
    SACInput,
    SACDropdown,
    ProcessOverlay,
  },
  props: {
    toggle: Function,
    states: Array,
    countries: Array,
    address: Object,
    update: Function,
    type: String,
  },
  data() {
    const {
      firstName = '',
      lastName = '',
      address1 = '',
      address2 = '',
      city = '',
      state = '',
      zip = '',
      country = '',
    } = this.address;
    return {
      firstName,
      lastName,
      address1,
      address2,
      city,
      state,
      zip,
      country,
      errorObj: {},
      updating: false,
    };
  },
  watch: {
    address(nAddress) {
      const {
        firstName = '',
        lastName = '',
        address1 = '',
        address2 = '',
        city = '',
        state = '',
        zip = '',
        country = '',
      } = nAddress;
      this.firstName = firstName;
      this.lastName = lastName;
      this.address1 = address1;
      this.address2 = address2;
      this.city = city;
      this.state = state;
      this.zip = zip;
      this.country = country;
      this.errorObj = {};
    },
  },
  methods: {
    onChange(field, value) {
      if (field === 'address') {
        Object.keys(value).forEach((k) => {
          if (this[k] !== undefined) {
            this[k] = value[k];
          }
        });
      } else {
        this[field] = value;
      }
    },
    async updatePartnerConfig() {
      const {
        firstName,
        lastName,
        address1,
        address2,
        city,
        state,
        zip,
        country,
      } = this;
      const errorObj = {};
      if (!firstName) {
        errorObj.firstNameErr = 'First name is required.';
      }
      if (!lastName) {
        errorObj.lastNameErr = 'Last name is required.';
      }
      if (!address1) {
        errorObj.address1Err = 'Street address is required.';
      }
      if (!city) {
        errorObj.cityErr = 'City is required.';
      }
      if (!state) {
        errorObj.stateErr = 'State is required.';
      }
      if (!zip) {
        errorObj.zipErr = 'Zip code is required.';
      }
      if (!country) {
        errorObj.countryErr = 'Country is required.';
      }
      this.errorObj = errorObj;
      if (Object.keys(errorObj).length === 0) {
        this.updating = true;
        await this.update({
          ...this.address,
          firstName,
          lastName,
          address1,
          address2,
          city,
          state,
          zip,
          country,
          type: this.type,
        });
        this.updating = false;
        this.$store.dispatch('showSuccessToast', {
          message: `Address ${address1} was ${this.address.id ? 'updated' : 'added'}`,
        });
        this.toggle(false);
      }
    },
  },
};
</script>
